import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field } from 'redux-form';
import ArrowUpBold from 'mdi-react/ArrowUpBoldIcon';
import ArrowDownBoldIcon from 'mdi-react/ArrowDownBoldIcon';
import TrashCanOutlineIcon from 'mdi-react/TrashCanOutlineIcon';
import renderField from '../../../shared/components/form/TextField';
import PopupAudioPlayer from '../../../shared/components/PopupAudioPlayer';

class RenderAudio extends PureComponent {
  static moveToUp(fields, index) {
    if (index > 0) {
      fields.swap(index, index - 1);
    }
  }

  static moveToDown(fields, index) {
    if (fields.length - 1 !== index) {
      fields.swap(index, index + 1);
    }
  }

  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.objectOf(PropTypes.any).isRequired,
    reduxFormName: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
  };

  render() {
    const {
      fields,
      reduxFormName,
      fieldName,
      meta: { error, submitFailed },
    } = this.props;
    const { moveToUp, moveToDown } = RenderAudio;

    return (
      <div className="form__form-group">
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" size="sm" onClick={() => fields.push({})}>
            Добавить аудио файл
          </Button>
        </ButtonToolbar>
        {submitFailed && error && (
          <div className="form__form-group">
            <div>
              <span className="form__form-group-error">{error}</span>
            </div>
          </div>
        )}
        {fields.map((customAudio, index) => (
          <div key={index} className="form__form-group">
            <span className="form__form-group-label">
              Аудио файл # {index + 1} (шорт-код %audiofile{index + 1}%)
            </span>
            <div className="form__form-group-field" style={{ marginBottom: '10px' }}>
              <Field
                name={`${customAudio}.source`}
                component={renderField}
                type="text"
                placeholder="Ссылка на aудио файл"
              />
              <PopupAudioPlayer
                title="Предварительное прослушивание"
                color="primary"
                reduxFormName={reduxFormName}
                fieldName={fieldName}
                fieldSubName="source"
                fieldIndex={index}
                header
              />
              <div className="form__form-group-icon">
                <ArrowUpBold onClick={() => moveToUp(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <ArrowDownBoldIcon onClick={() => moveToDown(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <TrashCanOutlineIcon onClick={() => fields.remove(index)} />
              </div>
            </div>
            <span className="form__form-group-label">Заглавие # {index + 1}</span>
            <div className="form__form-group-field">
              <Field name={`${customAudio}.title`} component={renderField} type="text" placeholder="Заглавие" />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default RenderAudio;
